<script setup>
  import _ from 'lodash'
  import navItems from '@/navigation/index'
  import adminNavItems from '@/navigation/admin'
  import {
    themeConfig
  } from '@themeConfig'

  // Components
  import Footer from '@/layouts/components/Footer.vue'
  import NavbarThemeSwitcher from '@/layouts/components/NavbarThemeSwitcher.vue'
  import UserProfile from '@/layouts/components/UserProfile.vue'
  import NavBarI18n from '@core/components/I18n.vue'

  // @layouts plugin
  import {
    VerticalNavLayout
  } from '@layouts'
  import pageLogo from '@images/logo.png'

  // --------------- 👉 User Pinia Store
  import {
    useStore
  } from '@/stores/user'
  const userStore = useStore()
  // --------------- 👉 User Pinia Store
  const featureKeys = userStore.featureKeys
  const roles = userStore.roles

  const navList = computed(() => {
    if (_.includes(userStore.roles, 'distributor_admin') || _.includes(userStore.roles, 'distributor_hr')) {
      return _.concat(navItems, adminNavItems)
    } else {
      return navItems
    }
  })
    const slug = localStorage.getItem('slug')

  import healthCoinSvg from '@images/svg/HealthCoin.svg'
  import shareCoinDescription from '@/components/share/coin-description.vue'
</script>

<template>
  <VerticalNavLayout :nav-items="navList">
    <!-- 👉 navbar -->
    <template #navbar="{ toggleVerticalOverlayNavActive }">
      <div class="d-flex h-100 align-center">
        <IconBtn id="vertical-nav-toggle-btn" data-testid="vertical-nav-toggle-btn" class="ms-n2 d-lg-none" @click="toggleVerticalOverlayNavActive(true)">
          <VIcon icon="ri-menu-line" />
        </IconBtn>
            <NuxtLink to="/" class="d-flex align-start ml-2 gap-x-4">
                <img :src="$siteLogo()" class="page-logo-style">
            </NuxtLink>
        <!-- <NavbarThemeSwitcher /> -->

        <VSpacer />
        <NavBarI18n v-if="themeConfig.app.i18n.enable && themeConfig.app.i18n.langConfig?.length"
          :languages="themeConfig.app.i18n.langConfig" />
        <UserProfile />
      </div>
    </template>


    <div class="d-flex justify-end align-center mb-5 mt-0" v-if="$includes(['mixcare'], slug)">
      <Component :is="healthCoinSvg" class="mr-1" />
      {{  $t('healthcoin') }}:
      <div class="ml-2 mb-0">
        {{ $coinTag($get(userStore, 'info.reward_points')) }}
      </div>
    </div>
    <!-- 👉 Pages -->
    <slot />

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </VerticalNavLayout>
</template>